import { attr } from '@ember-data/model';
import Super from './document-request';

export default class DocumentRequestStoredDocument extends Super {
  documentIcon = 'file-text';
  mixpanelType = 'PDF';

  @attr() documentExt;
  @attr() documentMimeType;
}
